import React, { PropsWithChildren } from 'react';
import { Nullable } from 'global';
import { ProposalSaleType } from '@trnsact/trnsact-shared-types';

import { FinanceProgramFormValues } from '../../types';
import { ProposalAdapter, DecisionAdapter } from './adapters';

interface Props {
  proposalId?: Nullable<string>;
  proposalSaleType?: Nullable<ProposalSaleType>;
  decisionId?: Nullable<string>;
  formDefaultValues?: FinanceProgramFormValues;
}

export const EditAdapter = (props: PropsWithChildren<Props>) => {
  const { children, proposalId = null, decisionId = null, formDefaultValues, proposalSaleType = null } = props;

  if (proposalId) {
    return (
      <ProposalAdapter
        proposalId={proposalId}
        proposalSaleType={proposalSaleType}
        formDefaultValues={formDefaultValues}
      >
        {children}
      </ProposalAdapter>
    );
  }

  if (decisionId) {
    return (
      <DecisionAdapter decisionId={decisionId} formDefaultValues={formDefaultValues}>
        {children}
      </DecisionAdapter>
    );
  }

  return children;
};
